import { Feature } from '../common'
import { PAGES } from '../../constants/GLOBAL_VARIABLE'

const DROPS_TARGET = 'discord' // 실제 링킹 대상 플랫폼은 디스코드이므로 discord로 설정합니다.

export default class DiscotechLinking extends Feature {
  constructor({ mainUrl }) {
    super({ namespace: 'ial', enumKey: 'IAL.DISCOTECH_LINKING' })
    this.mainUrl = mainUrl || 'https://signin.nexon.com'

    const {
      link_ticket: linkTicket,
      code,
      state,
      error,
    } = this.queryParam

    /**
     * INSIGN-Front에서 디스코테크 링킹 조회 API에서 링킹 정보가 없을 경우 획득하는 일회성 값입니다.
     * 링킹 과정에서 해당 값의 영속성을 보장하기 위해 INSGIN-GW를 통해 쿠키에 저장한 뒤 INSGIN-Front로 되돌아갑니다.
     */
    this.linkTicket = linkTicket

    /**
     * 아래 파라미터는 디스코드 Authorization Code Grant 요청의 결과로 전달받는 값입니다.
     * - code: Authorization Code
     * - state: CSRF 방어용으로 사용되는 값
     * - error: 'access_denied' 등 Discord에서 발생하는 에러 코드입니다.
     *   - (참고) access_denied: 사용자가 권한 부여를 거부한 경우
     *
     * ref: https://discord.com/developers/docs/topics/oauth2
     */
    this.code = code
    this.error = error
    this.state = state
    this.target = DROPS_TARGET

    console.debug('[DiscotechLinking Instance]', this)
  }

  setCookie() {
    const cookieData = {
      target: this.target,
      ...(this.linkTicket && { link_ticket: this.linkTicket }),
      ...(this.code && { code: this.code }),
      ...(this.state && { state: this.state }),
      ...(this.error && { error: this.error }),
    }
    this.namespaceCookie.setCookie(cookieData)
  }

  clearCookie() {
    this.namespaceCookie.clearCookie()
  }

  gotoDiscotechLinkingPage() {
    this.navigateToUrlWithoutHistory(`${this.mainUrl}/${PAGES.IAL_DISCOTECH_LINKING}`)
  }

  processLinking() {
    this.clearCookie()
    this.setCookie()
    this.gotoDiscotechLinkingPage()
  }
}
